import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Controller, Autoplay, Thumbs } from 'swiper/core';
import $ from 'jquery';

class ImageSlideshow {
	constructor() {
		this.init();
	}

	init() {
		SwiperCore.use([Navigation, Pagination, Controller, Autoplay, Thumbs]);

		$('.hb-slider').each(function (e) {
			var main = $(this).find('> .main').get(0);
			var thumbs = $(this).find('> .thumbs').get(0);
			var sliderSpeed = $(this).data('slider-speed') ?? 2000;

			var mainSlider = new Swiper(main, {
				spaceBetween: 0,
				centeredSlides: false,
				loop: true,
				direction: 'horizontal',
				loopedSlides: 5,
				autoplay: {
					delay: sliderSpeed,
					disableOnInteraction: false,
				},
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				resizeObserver: true,
			});

			var thumbsSlider = new Swiper(thumbs, {
				spaceBetween: 10,
				centeredSlides: true,
				loop: true,
				slideToClickedSlide: true,
				direction: 'horizontal',
				slidesPerView: 5,
				loopedSlides: 5,
			});

			mainSlider.controller.control = thumbsSlider;
			thumbsSlider.controller.control = mainSlider;
		});
	}
}

export default ImageSlideshow;
